import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-1" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mb-8 d-flex align-center" }
const _hoisted_4 = { class: "my-8" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: [{ title: '園児・保護者情報', href: '/children', color: 'primary', disabled: false },
        {title: `${_ctx.child?.lastName } ${ _ctx.child?.firstName }`,disabled: true}]
      }, null, 8, ["items"])
    ]),
    (_ctx.child)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.child.lastName) + " " + _toDisplayString(_ctx.child.firstName), 1),
            _createVNode(_component_v_spacer),
            _createElementVNode("div", null, [
              _createVNode(_component_v_btn, {
                color: "primary",
                class: "mr-4",
                variant: "outlined",
                onClick: _ctx.invitationDownload,
                disabled: _ctx.isDownloading || _ctx.loading
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { start: "" }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("mdi-tray-arrow-down", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[1] || (_cache[1] = _createTextVNode(" 案内状ダウンロード ", -1))
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_v_btn, {
                onClick: _ctx.deleteChild,
                disabled: _ctx.loading,
                class: "mr-4",
                color: "error",
                variant: "flat"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" 削除 ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_v_btn, {
                disabled: _ctx.loading,
                color: "primary",
                variant: "flat",
                to: `/children/account/${_ctx.child.childId}/edit`
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("編集", -1)
                ]))]),
                _: 1
              }, 8, ["disabled", "to"])
            ])
          ]),
          _createElementVNode("div", null, [
            (_ctx.isDownloading)
              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 0,
                  indeterminate: "",
                  color: "primary",
                  class: "my-8"
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_img, {
              width: "200px",
              src: _ctx.child.imageUrl
            }, null, 8, ["src"])
          ]),
          _cache[19] || (_cache[19] = _createElementVNode("h3", null, _toDisplayString(`園児情報`), -1)),
          _createVNode(_component_v_table, { class: "mt-4" }, {
            default: _withCtx(() => [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("td", { class: "font-weight-bold" }, "園児区分", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.childType), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("td", { class: "font-weight-bold" }, "ログインID", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.child.childCode), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[6] || (_cache[6] = _createElementVNode("td", { class: "font-weight-bold" }, "初回パスワード", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.child.password), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[7] || (_cache[7] = _createElementVNode("td", { class: "font-weight-bold" }, "園児コード", -1)),
                  _createElementVNode("td", null, [
                    (_ctx.childType.optionalChildCode1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.childType.optionalChildCode1) + ", ", 1))
                      : _createCommentVNode("", true),
                    (_ctx.childType.optionalChildCode2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.childType.optionalChildCode2), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[8] || (_cache[8] = _createElementVNode("td", { class: "font-weight-bold" }, "生年月日", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.child.dateOfBirth), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[9] || (_cache[9] = _createElementVNode("td", { class: "font-weight-bold" }, "性別", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.child.gender == "male" ? "男性" : "女性"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("td", { class: "font-weight-bold" }, "入園日 (予定)", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.child.admissionDate), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[11] || (_cache[11] = _createElementVNode("td", { class: "font-weight-bold" }, "卒園日 (予定)", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.child.graduationDate), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[12] || (_cache[12] = _createElementVNode("td", { class: "font-weight-bold" }, "退園・転園日", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.child.quitDate), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("td", { class: "font-weight-bold" }, "クラス", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.classNames), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[14] || (_cache[14] = _createElementVNode("td", { class: "font-weight-bold" }, "グループ", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.groupNames), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[15] || (_cache[15] = _createElementVNode("td", { class: "font-weight-bold" }, "延長保育パターン", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.child.hoursPattern ? _ctx.child.hoursPattern.patternTitle : ""), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[16] || (_cache[16] = _createElementVNode("td", { class: "font-weight-bold" }, "配慮が必要な園児への保育者加配", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.child.additionalStaffNum), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[17] || (_cache[17] = _createElementVNode("td", { class: "font-weight-bold" }, "補助金の上限額", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.child.maxSubsidyAmount), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "mt-6" }, "ログイン情報", -1)),
          _createVNode(_component_v_table, { class: "mt-4" }, {
            default: _withCtx(() => [
              _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "氏名"),
                  _createElementVNode("th", null, "続柄"),
                  _createElementVNode("th", null, "ログイン方法"),
                  _createElementVNode("th", null, "登録メールアドレス")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authMethodsResponse, (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, _toDisplayString(`${item.parentUser.lastName || ""} ${
                    item.parentUser.firstName || ""
                  }`), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.getParentTypeText(item.parentUser.parentType)), 1),
                    _createElementVNode("td", null, _toDisplayString(item.method == "auth0"
                    ? "メールアドレス・パスワード"
                    : item.method), 1),
                    _createElementVNode("td", null, _toDisplayString(item.method == "apple" ? "" : `${item.parentUser.email || ""}`), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}